var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeecount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-989.000000, -395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29)-Widgets/3)-Statistics/9)-Sales-2-Copy-7",
    transform: "translate(976.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy-6",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-employee-2685671-(1)",
    transform: "translate(11.000000, 8.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07674569,11.300431 C6.09720284,11.3106596 6.11743306,11.3208882 6.13789138,11.3411184 C7.08481164,11.9521098 8.21520388,12.3085214 9.42694526,12.3085214 C10.6386866,12.3085214 11.7588375,11.9521098 12.7159991,11.3513598 C12.7364563,11.3309026 12.7669151,11.320901 12.7973716,11.3004438 C14.4673565,10.2007757 15.5673155,8.31688565 15.5673155,6.17841582 C15.5673155,2.79748047 12.8178543,0.0481356466 9.43703534,0.0481356466 C6.05633276,0.0481356466 3.29686293,2.78735547 3.29686293,6.16852358 C3.29686293,8.31723478 4.39676379,10.2011249 6.07699009,11.300793 L6.07674569,11.300431 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6225431,13.0210991 L7.38007759,22.359375 L9.4269569,25.078403 L11.4738362,22.3494246 L10.2313707,13.0111487 C9.96656121,13.0416075 9.70175172,13.0620647 9.4269569,13.0620647 C9.15191767,13.0620647 8.88734095,13.0518361 8.6225431,13.0211503 L8.6225431,13.0210991 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8255172,17.5732759 C18.8255172,15.2209009 17.9804289,13.7139052 16.1778879,12.8380927 C15.3734741,12.4512246 14.3653966,12.1966681 13.0617737,12.0234375 C12.4302996,12.4205353 11.7379591,12.7058276 10.9947026,12.8787672 L12.2573599,22.4102328 C12.2675885,22.5120647 12.2471313,22.6138966 12.1859845,22.685272 L9.74201897,25.9438927 C9.67064353,26.0354948 9.55881466,26.0966405 9.43652328,26.0966405 C9.3142319,26.0966405 9.20240302,26.0354948 9.13102759,25.9438927 L6.68706207,22.685272 C6.62591638,22.6038996 6.60568966,22.5020677 6.61568664,22.4102328 L7.87834397,12.8787672 C7.1350875,12.7055599 6.44245603,12.410294 5.81127284,12.0234375 C1.76866293,12.5223672 0.027512069,14.1823901 0.027512069,17.5732759 L0.027512069,26.972069 L18.8157879,26.972069 L18.8157879,17.5732759 L18.8255172,17.5732759 Z",
    id: "Path"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeecount);
export default __webpack_public_path__ + "static/media/Employee count.d669f7a272cde7ae1d18b3df52c4941b.svg";
export { ForwardRef as ReactComponent };